/**
 * Ensemble is the Module Federation host (`moduleFederation.host` in package.json), so
 * whichever version of a shared singleton it loads first is the one every remote is
 * forced to reuse (see PVDS_LIBRARIES in rspack.common.ts). That only happens for PVDS
 * packages Ensemble's own code already imports — anything Ensemble never references
 * (e.g. pv-filter) never registers here, leaving whichever remote uses it first to set
 * the version instead, which can silently mismatch against the rest of the PVDS set a
 * remote was actually built and tested against.
 *
 * Importing every shared PVDS package here, purely for its side effects, makes Ensemble's
 * own pinned versions authoritative for the whole federation graph. Keep this list in sync
 * with PVDS_LIBRARIES in rspack.common.ts.
 *
 * These must be dynamic `import()` calls, not static imports: none of these are
 * configured `eager: true` in the shared config, so Module Federation only allows
 * consuming them through an async boundary. A static import hits the synchronous
 * `loadShareSync` path and throws ("Invalid loadShareSync function call ... RUNTIME-006").
 */
import('@planview/pv-tokens');
import('@planview/pv-details');
import('@planview/pv-editor');
import('@planview/pv-filter');
import('@planview/pv-form');
import('@planview/pv-grid');
import('@planview/pv-icons');
import('@planview/pv-toolbar');
import('@planview/pv-uikit');
import('@planview/pv-utilities');
import('@planview/pv-widget');
